import React from "react"
import { Box, SimpleGrid, Heading } from "@chakra-ui/core"
import ReactMarkdown from "react-markdown"
import Img from "gatsby-image"

const Service = ({ services, name }) => {
  return (
    <Box py="50px" w="100%" maxW="1140px" pb="110px" mx="auto" px="15px">
      <Heading id="services" pb="10px" pt="60px">
        {name}
      </Heading>
      <SimpleGrid columns={{base: 1, lg: 3}} spacing={10}>
        {services.map(({ serviceDescription, serviceImage, serviceName }) => (
          <Box
            key={serviceName}
            bg="gray.100"
            minH="300px"
            border="1px"
            borderColor="gray.300"
            borderRadius="md"
          >
            <Box maxH="200px" w="100%" overflow="hidden" bgColor="gray.300">
              <Img
                fluid={serviceImage.fluid}
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </Box>
            <Box padding="15px">
              <Heading as="h3" size="md" mb="10px">
                {serviceName}
              </Heading>
              <ReactMarkdown
                source={serviceDescription.childMarkdownRemark.rawMarkdownBody}
              />
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  )
};

export default Service
